









import Vue, { PropType } from "vue";
import { Data, Methods, Computed, Props } from "./types";

export default Vue.extend<Data, Methods, Computed, Props>({
  name: "ButtonConfig",
  props: {
    position: {
      type: String as PropType<Props["position"]>,
      default: "",
      required: false,
      validator(value) {
        return ["", "left", "center", "right"].includes(value);
      }
    }
  },
  computed: {
    positionClass() {
      return {
        "buttonConfig--position-left": this.position === "left",
        "buttonConfig--position-center": this.position === "center",
        "buttonConfig--position-right": this.position === "right"
      };
    }
  }
});
